/* eslint-disable global-require */
import {
  User,
  Key,
  Users,
  // Settings,
  Download,
  Mail,
  Gift,
  BarChart,
  FileText,
  DollarSign,
  Award,
  UserCheck,
  Folder,
} from 'react-feather'
import EventIcon from 'src/icons/EventIcon'

export const roleAccess = {
  // USER
  1: [
    {
      default: true,
      name: 'examsUser',
      title: 'آزمون‌ها',
      // icon: FileText,
      icon: FileText,
      href: '/app/exams/user',
    },
    {
      name: 'publicCourses',
      title: 'مسیر دانایی',
      icon: require('../icons/PublicCourseIconOne').default,
      href: '/app/courses/user/public-courses',
    },
    {
      name: 'professionalCourses',
      title: 'مسیر گارنت',
      icon: require('../icons/PublicCourseIcon').default,
      iconTwo: require('../icons/ProfessionalCourseIconDark').default,
      href: '/app/courses/user/professional-courses',
      children: [
        {
          name: 'boughtCourses',
          title: 'دوره های خریداری شده',
          href: '/app/courses/user/bought-courses',
        },
      ],
    },
    {
      name: 'professionalCourses',
      title: 'نتیجه آزمون',
      icon: require('../icons/CourseResultIcon').default,
      href: '/app/courses/user/course-result',
    },
    {
      name: 'professionalCourses',
      title: 'درخواست گواهینامه',
      icon: require('../icons/CertificateIcon').default,
      href: '/app/courses/user/certificate',
    },
    {
      name: 'scholarship',
      title: 'درخواست بورسیه',
      icon: Award,
      href: '/app/scholarship',
    },
    {
      name: 'events',
      title: 'شرکت در رویداد ',
      icon: EventIcon,
      href: '/app/events/user',
    },
    {
      name: 'profileEdit',
      title: 'ویرایش پروفایل',
      icon: User,
      href: '/app/profile/edit',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
    {
      name: 'notificationUser',
      title: 'اعلانیه‌ها',
      icon: Download,
      href: '/app/notifications/user',
    },
    {
      name: 'chatUser',
      title: 'مکالمات',
      icon: Mail,
      href: '/app/chats/user',
    },
  ],
  // SUPPER ADMIN
  2: [
    {
      default: true,
      name: 'dashboard',
      title: 'داشبورد',
      icon: require('../icons/Dashboard').default,
      href: '/app/dashboard',
    },
    {
      name: 'users',
      title: 'مدیریت کاربران',
      icon: require('../icons/UserManage').default,
      href: '/app/users',
    },
    {
      name: 'customers',
      title: 'آزمون دهنده ها',
      // icon: Users,
      icon: require('../icons/UsersTesting').default,
      href: '/app/customers',
    },
    {
      name: 'examsAdmin',
      title: 'بسته های آزمون',
      // icon: Folder,
      icon: require('../icons/TestPackages').default,
      href: '/app/exams/packages',
    },
    {
      name: 'publicCourses',
      title: 'مسیر دانایی',
      icon: require('../icons/PublicCourseIconOne').default,
      href: '/app/courses/admin/public-courses',
    },
    {
      name: 'professionalCourses',
      title: 'مسیر گارنت',
      icon: require('../icons/PublicCourseIcon').default,
      href: '/app/courses/admin/professional-courses',
    },
    {
      name: 'professionalCourses',
      title: 'درخواست گواهینامه',
      icon: require('../icons/CertificateIcon').default,
      href: '/app/courses/admin/certificate',
    },
    {
      name: 'scholarships',
      title: 'بورسیه‌ها',
      // icon: Award,
      icon: require('../icons/Bursie').default,
      href: '/app/scholarships',
    },
    {
      name: 'sales',
      title: 'گزارش فروش',
      // icon: DollarSign,
      icon: require('../icons/SaleFactor').default,
      href: '/app/sales',
    },
    {
      name: 'AffiliateMarketing',
      title: 'افیلیت مارکتینگ',
      icon: Gift,
      href: '/app/affiliateMarketing/admin/',
    },
    {
      name: 'events',
      title: 'رویداد ها',
      icon: EventIcon,
      href: '/app/events/admin',
    },
    {
      name: 'chatsAdmin',
      title: 'مدیریت مکالمات',
      // icon: Mail,
      icon: require('../icons/ManageCalls').default,
      href: '/app/chats/admin',
    },
    {
      name: 'discounts',
      title: 'تخفیف‌ها',
      // icon: Gift,
      icon: require('../icons/Discounts').default,
      href: '/app/discounts',
    },
    {
      name: 'extend',
      title: 'تمدید آزمون ها',
      icon: require('../icons/SaleFactor').default,
      href: '/app/extend',
    },
    {
      name: 'notificationAdmin',
      title: 'مدیریت اعلانات',
      icon: Download,
      href: '/app/notifications/admin',
    },
    {
      name: 'referee',
      title: 'گروه‌های داوری',
      icon: UserCheck,
      href: '/app/referee',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // ADMIN
  3: [
    {
      default: true,
      name: 'dashboard',
      title: 'داشبورد',
      icon: BarChart,
      href: '/app/dashboard',
    },
    {
      name: 'users',
      title: 'مدیریت کاربران',
      icon: User,
      href: '/app/users',
    },
    {
      name: 'notificationAdmin',
      title: 'مدیریت اعلانیه',
      icon: Download,
      href: '/app/notifications/admin',
    },
    {
      name: 'examsAdmin',
      title: 'آزمون‌ها',
      icon: FileText,
      href: '/app/exams/admin',
    },
    {
      name: 'examsPackages',
      title: 'بسته های آزمون',
      icon: Folder,
      href: '/app/exams/packages',
    },
    {
      name: 'scholarships',
      title: 'بورسیه‌ها',
      icon: Award,
      href: '/app/scholarships',
    },
    {
      name: 'sales',
      title: 'گزارش فروش',
      icon: DollarSign,
      href: '/app/sales',
    },
    {
      name: 'chatsAdmin',
      title: 'مدیریت مکالمات',
      icon: Mail,
      href: '/app/chats/admin',
    },
    {
      name: 'discounts',
      title: 'تخفیف‌ها',
      icon: Gift,
      href: '/app/discounts',
    },
    {
      name: 'extend',
      title: 'تمدید آزمون ها',
      icon: Gift,
      href: '/app/extend',
    },
    {
      name: 'notificationAdmin',
      title: 'مدیریت اعلانات',
      icon: Download,
      href: '/app/notifications/admin',
    },
    {
      name: 'referee',
      title: 'گروه‌های داوری',
      icon: UserCheck,
      href: '/app/referee',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // FINANCIAL MANAGER
  4: [
    {
      default: true,
      name: 'discounts',
      title: 'تخفیف‌ها',
      icon: Gift,
      href: '/app/discounts',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // SCHOLARSHIP MANAGER
  5: [
    {
      name: 'users',
      title: 'مدیریت داوران',
      icon: User,
      href: '/app/users',
    },
    {
      name: 'scholarships',
      title: 'مدیریت بورسیه‌',
      icon: Award,
      href: '/app/scholarships',
    },
    {
      name: 'referee',
      title: 'گروه‌های داوری',
      icon: UserCheck,
      href: '/app/referee',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // REFEREE
  6: [
    {
      default: true,
      name: 'scholarships',
      title: 'مدیریت بورسیه‌',
      icon: Award,
      href: '/app/scholarships',
    },
    {
      name: 'events',
      title: 'مدیریت رویداد',
      icon: Gift,
      href: '/app/events/admin',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // SUPPORT
  7: [
    {
      default: true,
      name: 'chatsAdmin',
      title: 'مدیریت مکالمات',
      icon: Mail,
      href: '/app/chats/admin',
    },
    {
      name: 'notificationAdmin',
      title: 'مدیریت اعلانات',
      icon: Download,
      href: '/app/notifications/admin',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
  ],
  // DEVELOPER
  8: [
    {
      default: true,
      name: 'dashboard',
      title: 'داشبورد',
      icon: BarChart,
      href: '/app/dashboard',
    },
    {
      name: 'users',
      title: 'مدیریت کاربران',
      icon: User,
      href: '/app/users',
    },
    {
      name: 'customers',
      title: 'آزمون دهنده ها',
      icon: Users,
      href: '/app/customers',
    },
    {
      name: 'examsPackages',
      title: 'بسته های آزمون',
      icon: Folder,
      href: '/app/exams/packages',
    },
    {
      name: 'scholarships',
      title: 'بورسیه‌ها',
      icon: Award,
      href: '/app/scholarships',
    },
    {
      name: 'sales',
      title: 'گزارش فروش',
      icon: DollarSign,
      href: '/app/sales',
    },
    {
      name: 'chatsAdmin',
      title: 'مدیریت مکالمات',
      icon: Mail,
      href: '/app/chats/admin',
    },
    {
      name: 'discounts',
      title: 'تخفیف‌ها',
      icon: Gift,
      href: '/app/discounts',
    },
    {
      name: 'notificationAdmin',
      title: 'مدیریت اعلانات',
      icon: Download,
      href: '/app/notifications/admin',
    },
    {
      name: 'referee',
      title: 'گروه‌های داوری',
      icon: UserCheck,
      href: '/app/referee',
    },
    {
      name: 'profileChangePassword',
      title: 'تغییر رمز عبور',
      icon: Key,
      href: '/app/profile/change-password',
    },
    // {
    // name: 'settings',
    // title: 'تنظیمات',
    // icon: Settings,
    // href: '/app/settings',
    // },
  ],
  9: [
    {
      // name: 'AffiliateMarketing',
      title: 'افیلیت مارکتینگ',
      icon: Gift,
      href: '/app/affiliateMarketing/user/',
    },
  ],
  // EVENT MANAGER
  10: [
    {
      name: 'events',
      title: 'رویداد ها',
      icon: Gift,
      href: '/app/events/admin',
    },
    {
      name: 'referee',
      title: 'گروه‌های داوری',
      icon: UserCheck,
      href: '/app/referee',
    },
    {
      name: 'users',
      title: 'مدیریت داوران',
      icon: User,
      href: '/app/users',
    },
    {
      name: 'stages',
      title: 'مراحل داوری',
      icon: User,
      href: '/app/stages',
    },
  ],
}
export default roleAccess
